/** Feature detection for Popover API */
export const supportsPopover = 'popover' in HTMLElement.prototype;
